var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#70797B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 2.2H15.2C16.6359 2.2 17.8 3.36406 17.8 4.8C17.8 6.23594 16.6359 7.4 15.2 7.4H4.8C3.36406 7.4 2.2 6.23594 2.2 4.8C2.2 3.36406 3.36406 2.2 4.8 2.2ZM1 4.8C1 2.70132 2.70132 1 4.8 1H15.2C17.2987 1 19 2.70132 19 4.8C19 6.89868 17.2987 8.6 15.2 8.6H4.8C2.70132 8.6 1 6.89868 1 4.8ZM4.8 12.6H15.2C16.6359 12.6 17.8 13.7641 17.8 15.2C17.8 16.6359 16.6359 17.8 15.2 17.8H4.8C3.36406 17.8 2.2 16.6359 2.2 15.2C2.2 13.7641 3.36406 12.6 4.8 12.6ZM1 15.2C1 13.1013 2.70132 11.4 4.8 11.4H15.2C17.2987 11.4 19 13.1013 19 15.2C19 17.2987 17.2987 19 15.2 19H4.8C2.70132 19 1 17.2987 1 15.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTable);
export default __webpack_public_path__ + "static/media/icon-table.d565503fb5d48c58c43b65e154b82595.svg";
export { ForwardRef as ReactComponent };